import { render, staticRenderFns } from "./TabsV2.vue?vue&type=template&id=6830831e&"
import script from "./TabsV2.vue?vue&type=script&lang=js&"
export * from "./TabsV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports